<div class="page-header">
    <div class="mobile-menu" (click)="openMenu()">
        <span class="icon-mobilize-mobile-menu"></span>
    </div>
    <div [ngClass]="{'reverse': reverse}">
        <div class="title" [ngClass]="{'reverse': reverse}">{{ title }}</div>
        @if (userLoaded) {
            <div class="subtitle" [ngClass]="{'reverse': reverse}">{{ user.full_name }} @if (user.partner_type === 'PJ') {/ {{user.partnerName}} }</div>
        }
    </div>

    @if (button) {
        <button class="mobilize-btn" [ngClass]="button.className" (click)="buttonAction()">{{ button.label }}</button>
    }
</div>
